module.exports = __webpack_public_path__ + "static/4 - Raptor 1-f3a9cc40f35ee9eeccf57f0b6f70a4a9.jpg";